import { observer } from "mobx-react-lite"
import { useMemo } from "react"

import { MarkdownWrapper } from "@/components/Markdown/MarkdownWrapper.tsx"
import { useScrollableModel } from "@/components/Scrollable/ScrollableContext.ts"
import { useStreamedText } from "@/hooks/useStreamedText.ts"
import { Characters } from "@/styles/textStyles.ts"

import type { DMDecoratedText } from "@/lib/client/generated/TypeDefinitions.ts"
import type { LinariaClassName } from "@linaria/core"


export type StreamedTextBlockProps = {
  text: string | DMDecoratedText
  isNew: boolean
  isStreamed: boolean
  isStreamCompleted: boolean
  className?: LinariaClassName
  symbolsPerSecond?: number
  symbolsPerSecondSmoothness?: number
  updateIntervalSeconds?: number
  maxCatchupTimeSeconds?: number
}
/**
 * If `text` is only a part of a bigger stream, then `isStreamCompleted` indicates the status of that parent stream
 */
export const StreamedTextBlock = observer((props: StreamedTextBlockProps) => {
  const scrollModel = useScrollableModel()

  const cleanedText = useMemo(() => {
    const text = typeof props.text === "string" ? props.text : props.text.value

    return text.replace(tagPattern, "")
  }, [props.text])

  const {
    streamedText,
    isStreamCompleted
  } = useStreamedText(cleanedText, props.isNew, props.isStreamCompleted, props).get()
  scrollModel.setAutoScroll(!isStreamCompleted)

  const displayText = props.isStreamed
    ? (isStreamCompleted ? streamedText : streamedText + Characters.Zwsp + Characters.MediumBlackCircle)
    : cleanedText

  return (
    <MarkdownWrapper
      text={displayText}
      className={props.className}
    />
  )
})

const tagsToRemove = ["assistant_message", "user_message"]
const tagPattern = new RegExp(`</?(${tagsToRemove.join("|")})\\b[^>]*>`, "g")